export const fileSource = 
{
    Url: 1,
    File: 2,
    Decompressed: 3
}

export const FileFormat = 
{
    Text: 1,
    Binary: 2
}

export function GetFileName (filePath)
{
	let firstSeparator = filePath.lastIndexOf ('/');
	if (firstSeparator === -1) {
		firstSeparator = filePath.lastIndexOf ('\\');
	}
	let fileName = filePath;
	if (firstSeparator !== -1) {
		fileName = filePath.substring (firstSeparator + 1);
	}
	let firstParamIndex = fileName.indexOf ('?');
	if (firstParamIndex !== -1) {
		fileName = fileName.substring (0, firstParamIndex);
	}
	return decodeURI (fileName);
}